import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { calculateMacroPercentages } from "../../../../../utils/nutrition-helpers";

const TemplateSelectionList = ({
  templates,
  selectedTemplateId,
  onSelect,
  onSave,
  emptyStateTitleKey,
  emptyStateDescriptionKey,
}) => {
  const { t } = useTranslation(["athlete-portal", "common"]);

  if (templates.length === 0) {
    return (
      <div className="empty-state">
        <p className="empty-state-title">{t(emptyStateTitleKey)}</p>
        <p className="empty-state-description">
          {t(emptyStateDescriptionKey)}
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="selection">
        <ul>
          {templates.map((template) => {
            const option = template.trainingDayOptions?.[0];
            if (!option) return null;

            const macros = option.macrosTotal || {};
            const percentages = calculateMacroPercentages(macros);
            const isSelected = selectedTemplateId === template._id;

            return (
              <li key={template._id}>
                <div className="macros-information">
                  <span>{template.title}</span>
                  <span className="opacity-70">{option.title}</span>
                  <div className="macros">
                    <div>
                      <div className="protein-container">P</div>
                      <span>
                        {macros.proteins || 0}g ({percentages.proteins}%)
                      </span>
                    </div>
                    <div>
                      <div className="carbs-container">C</div>
                      <span>
                        {macros.carbs || 0}g ({percentages.carbs}%)
                      </span>
                    </div>
                    <div>
                      <div className="fat-container">F</div>
                      <span>
                        {macros.fats || 0}g ({percentages.fats}%)
                      </span>
                    </div>
                    <div>
                      <div className="calories-container">K</div>
                      <span>{macros.calories || 0}</span>
                    </div>
                  </div>
                </div>
                <div className="checkbox">
                  <SvgIcon
                    onClick={() => onSelect(template._id)}
                    src={`/img/new-icons/${
                      isSelected ? "checked-square.svg" : "unchecked-square.svg"
                    }`}
                    noFilterOnLight={isSelected}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="footer">
        <button
          data-button-type="primary"
          onClick={onSave}
          disabled={!selectedTemplateId}
        >
          {t("common:save")}
        </button>
      </div>
    </>
  );
};

TemplateSelectionList.propTypes = {
  templates: PropTypes.array.isRequired,
  selectedTemplateId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  emptyStateTitleKey: PropTypes.string.isRequired,
  emptyStateDescriptionKey: PropTypes.string.isRequired,
};

export default TemplateSelectionList;
